<template>
  <div>
    <template v-if="isLoading">
      <Loading />
    </template>
    <template v-else-if="hasDbError">
      <Error v-for="(error, key) in dbErrors" v-if="error" :key="key" error="error" />
    </template>
    <template v-else-if="!isClubAdmin">
      <Error :error="$t('general.errors.needToBeAdmin')" />
    </template>
    <template v-else>
      <v-layout row wrap>
        <v-flex xs12>
          <WeekNavigate
            :year="year"
            :week="week"
            @movePrevWeek="movePrevWeek"
            @moveNextWeek="moveNextWeek"
          />
        </v-flex>
        <v-flex xs12>
          <a :href="excelDownload">{{ $t('page.addMatches.download') }}</a>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="excelName"
            :label="$t('page.addMatches.selectFile')"
            prepend-icon="attach_file"
            @click="pickFile"
          />
          <input
            ref="excelInput"
            type="file"
            style="display: none"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            @change="processFile"
          />
        </v-flex>
        <template v-if="matchesToAdd && matchesToAdd.length > 0">
          <v-flex xs12>
            <table class="matches_table">
              <tr>
                <th>{{ $t('general.valid') }}</th>
                <th>{{ $t('entity.match.sport.label') }}</th>
                <th>{{ $t('entity.match.date.label') }}</th>
                <th>{{ $t('entity.match.hour.label') }}</th>
                <th>{{ $t('entity.match.category.label') }}</th>
                <th>{{ $t('entity.match.visitorTeam.label') }}</th>
                <th>{{ $t('entity.match.localTeam.label') }}</th>
                <th>{{ $t('entity.match.location.label') }}</th>
                <th>{{ $t('entity.match.order.label') }}</th>
                <th>{{ $t('entity.match.day.label') }}</th>
              </tr>
              <tr
                v-for="(match, i) in matchesToAdd"
                :key="`match_${i}`"
                :class="{ hasError: match.error }"
              >
                <td>
                  <template v-if="match.error">
                    {{ match.error }}
                  </template>
                  <template v-else>
                    <v-icon>done</v-icon>
                  </template>
                </td>
                <td>{{ match.Sport }}</td>
                <td>{{ match.Date }}</td>
                <td>{{ match.Hour }}</td>
                <td>{{ match.Category }}</td>
                <td>{{ match.LocalTeam }}</td>
                <td>{{ match.VisitorTeam }}</td>
                <td>{{ match.Where }}</td>
                <td>{{ match.Order }}</td>
                <td>{{ match.SeassonDay }}</td>
              </tr>
            </table>
          </v-flex>
          <v-flex xs12>
            <v-btn :disabled="!validateMatches" class="success" @click="importMatches">
              {{ $t('page.addMatches.import') }}
            </v-btn>
            <v-btn class="error" @click="clean">{{ $t('general.cancel') }}</v-btn>
          </v-flex>
        </template>
        <v-flex xs12>
          <h2>{{ $t('page.clubs.weekMatches') }}</h2>
        </v-flex>
        <template v-if="matchesSort && matchesSort.length > 0">
          <v-flex xs12>
            <table class="matches_table">
              <tr>
                <th>{{ $t('entity.match.sport.label') }}</th>
                <th>{{ $t('entity.match.date.label') }}</th>
                <th>{{ $t('entity.match.hour.label') }}</th>
                <th>{{ $t('entity.match.category.label') }}</th>
                <th>{{ $t('entity.match.visitorTeam.label') }}</th>
                <th>{{ $t('entity.match.localTeam.label') }}</th>
                <th>{{ $t('entity.match.location.label') }}</th>
                <th>{{ $t('entity.match.order.label') }}</th>
                <th>{{ $t('entity.match.day.label') }}</th>
              </tr>
              <tr v-for="(match, i) in matchesSort" :key="`matches_${i}`">
                <td>{{ match.sport }}</td>
                <td>{{ match.date }}</td>
                <td>{{ match.hour }}</td>
                <td>{{ searchById('categories', match.category) }}</td>
                <td>{{ searchById('teams', match.localTeam) }}</td>
                <td>{{ searchById('teams', match.visitorTeam) }}</td>
                <td>{{ searchById('locations', match.location) }}</td>
                <td>{{ match.order }}</td>
                <td>{{ match.day }}</td>
              </tr>
            </table>
          </v-flex>
        </template>
      </v-layout>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import XLSX from 'xlsx'
import ClubUsersLib from '@/lib/data/clubUsers'
import ClubsLib from '@/lib/data/clubs'
import UsersLib from '@/lib/data/users'
import MatchesLib from '@/lib/data/matches'
import SportHelper from '@/lib/SportHelper'
import Loading from '@/components/UIComponents/Loading/Loading'
import Error from '@/components/UIComponents/Error/Error'
import BaseMixin from '@/components/Dashboard/Mixin/BaseMixin'
import SecurityHelper from '@/lib/SecurityHelper'
import DateHelper from '@/lib/DateHelper'
import WeekNavigate from '@/components/Dashboard/Views/Club/Views/WeekMatches/Templates/WeekNavigate'
const debug = require('debug')('OD::ClubAddMatches')

export default {
  name: 'ClubAddMatches',
  components: {
    Loading,
    Error,
    WeekNavigate,
  },
  mixins: [BaseMixin],
  props: {
    clubId: {
      type: String,
      required: true,
    },
    year: {
      type: String,
      required: true,
    },
    week: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      page: 'clubUsers',
      entity: 'clubUser',
      formError: '',
      club: {},
      clubUsers: [],
      users: [],
      matches: [],
      loadings: {
        clubUsers: true,
        matches: true,
        users: true,
        club: true,
      },
      dbErrors: {
        clubUsers: null,
        matches: null,
        users: null,
        club: null,
      },
      matchesToAdd: [],
      excelName: null,
      excelDownload:
        'https://firebasestorage.googleapis.com/v0/b/results-firebase.appspot.com/o/downloads%2FSigueTuClub_Matches.xlsx?alt=media&token=a42e34d9-ecb8-4dd1-8395-67c98e45d615',
    }
  },
  computed: {
    isLoading() {
      return _.values(this.loadings).filter(loading => loading).length > 0
    },
    hasDbError() {
      return _.values(this.dbErrors).filter(error => error && error !== '').length > 0
    },
    isClubAdmin() {
      return SecurityHelper.isClubAdmin(this.currentUser, this.clubUsers, this.clubId)
    },
    matchesSort() {
      return this.matches.slice(0).sort((a, b) => {
        const dateA = new Date(a.date + ' ' + a.hour)
        const dateB = new Date(b.date + ' ' + b.hour)
        return dateB > dateA ? -1 : dateB < dateA ? 1 : 0
      })
    },
    validateMatches() {
      debug('this.matchesToAdd.length', this.matchesToAdd.length)
      if (this.matchesToAdd.length > 0) {
        let globalValid = true
        // Fields not empty
        this.matchesToAdd.forEach(match => {
          debug('match', match)
          match.error = null
          const arrayExists = [
            'Sport',
            'Date',
            'Hour',
            'Category',
            'LocalTeam',
            'VisitorTeam',
            'Where',
            'Sport',
            'Order',
          ]
          arrayExists.forEach(field => {
            if (!match[field]) {
              match.error = `${field} can't be empty`
            }
          })
          // Sport valid
          if (!match.error) {
            const arrayOfSports = [
              'volleyball_federate_5sets',
              'volleyball_federate_3sets',
              'volleyball_federate_3sets_25',
              'volleyball_municipal_3sets',
              'volleyball_municipal_3sets_25',
              'volleyball_2sets_25',
              'badminton_3sets_21',
              'badminton_3sets_15',
              'rugby_union',
              'rugby_seven',
              'soccer_11players',
              'soccer_7players',
              'indoor_soccer_basic',
              'baseball',
              'softball',
              'basketball',
              'handball',
            ]
            if (!arrayOfSports.includes(match.Sport)) {
              match.error = `Sport ${match.Sport} not valid`
            }
          }
          // Numeric
          if (!match.error) {
            const arrayNumeric = ['Order', 'SeassonDay']
            arrayNumeric.forEach(field => {
              if (match[field]) {
                if (!Number.isInteger(match[field])) {
                  match.error = `${field} must be a integer`
                }
              }
            })
          }
          // Date regex
          if (!match.error) {
            const hourRegex = /^\d{4}-\d{2}-\d{2}$/g
            if (!match.Date.match(hourRegex)) {
              match.error = `Date bad format`
            }
          }
          // Hour regex
          if (!match.error) {
            const hourRegex = /^\d{1,2}:\d{2}$/g
            if (!match.Hour.match(hourRegex)) {
              match.error = `Hour bad format`
            }
          }
          // Data in week
          if (!match.error) {
            const weekDates = DateHelper.getWeekDates(this.year, this.week)
            debug('weekDates', weekDates)
            const matchDate = new Date(match.Date)
            if (
              matchDate < new Date(weekDates[0]) ||
              matchDate > new Date(weekDates[weekDates.length - 1])
            ) {
              match.error = `Date outside week`
            }
          }
          if (match.error) {
            globalValid = false
          }
        })
        return globalValid
      }
      return true
    },
  },
  watch: {
    currentUser() {
      this.bind()
    },
    formError() {
      if (this.formError) {
        this.snackbarOpen = true
      }
    },
    club() {
      if (this.club) {
        this.$emit('updateHead')
      }
    },
    clubId() {
      this.bind()
    },
    year() {
      this.bind()
    },
    week() {
      this.bind()
    },
  },
  created() {},
  mounted() {
    this.bind()
  },
  beforeDestroy() {},
  methods: {
    bind() {
      ClubUsersLib.bindAll(this, { clubId: this.clubId })
      ClubsLib.bindItem(this, { clubId: this.clubId })
      UsersLib.bindAll(this)
      MatchesLib.bindAll(this, { clubId: this.clubId, year: this.year, week: this.week })
    },
    processFile(event) {
      const file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = e => {
        let binary = ''
        const bytes = new Uint8Array(e.target.result)
        const length = bytes.byteLength
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        // call 'xlsx' to read the file
        const Workbook = XLSX.read(binary, { type: 'binary', cellDates: false, cellStyles: true })
        const worksheet = Workbook.Sheets.matches
        const arrayOfMatches = XLSX.utils.sheet_to_row_object_array(worksheet)
        this.matchesToAdd = arrayOfMatches.map(match => {
          return Object.assign({ error: null }, match)
        })
        this.$refs.excelInput.value = ''
      }
      reader.readAsArrayBuffer(file)
    },
    pickFile() {
      this.$refs.excelInput.click()
    },
    clean() {
      this.matchesToAdd = []
      this.$refs.excelInput.value = ''
    },
    searchById(searchArray, id) {
      const item = this.club.search[searchArray].find(item => {
        return item.id === id
      })
      return item.text
    },
    search(searchArray, searchField, value) {
      const item = this.club.search[searchArray].find(item => {
        return item[searchField] === value
      })
      let itemId = null
      if (item) {
        itemId = item.id
      } else {
        const data = {}
        data[searchField] = value
        itemId = ClubsLib.addSuggestion(this, {
          clubId: this.clubId,
          data: data,
          key: searchArray,
          duplicate: false,
        })
      }
      return itemId
    },
    getSport(sport) {
      return SportHelper.getSportConfiguration(sport)
    },
    async importMatches() {
      for (const match of this.matchesToAdd) {
        debug('match', match)
        const categoryId = this.search('categories', 'text', match.Category)
        const localTeamId = this.search('teams', 'text', match.LocalTeam)
        const visitorTeamId = this.search('teams', 'text', match.VisitorTeam)
        const locationId = this.search('locations', 'text', match.Where)
        const data = {
          sport: match.Sport,
          category: categoryId,
          date: match.Date,
          hour: match.Hour,
          localTeam: localTeamId,
          location: locationId,
          order: String(match.Order),
          day: match.SeassonDay ? String(match.SeassonDay) : '',
          visitorTeam: visitorTeamId,
        }
        const sport = this.getSport(match.Sport)
        await MatchesLib.add(this, this.currentUser, data, this.club, sport, {
          clubId: this.clubId,
          year: this.year,
          week: this.week,
        })
      }
      this.clean()
    },
    movePrevWeek(data) {
      this.$router.push({
        name: 'ClubAddMatches',
        params: {
          clubId: this.clubId,
          year: `${data.year}`,
          week: `${data.week}`,
        },
      })
    },
    moveNextWeek(data) {
      this.$router.push({
        name: 'ClubAddMatches',
        params: {
          clubId: this.clubId,
          year: `${data.year}`,
          week: `${data.week}`,
        },
      })
    },
  },
  head: {
    title: function() {
      const club = this.club && this.club.club ? this.club.club : ''
      return {
        inner: `${club || ''} | ${this.$t('page.clubUsers.title')}`,
      }
    },
  },
}
</script>

<style lang="scss">
.matches_table {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  th,
  td {
    text-align: left;
  }
  tr.hasError {
    color: red;
  }
}
</style>
